'use client';

import {Error505} from '@web-landing/components/Error505/Error505';

export default function Error(props: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  return <Error505 {...props} />;
}
